// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8b46720","952":"cb03f2e2"}[chunkId] + ".chunk.js";
};